export default __webpack_public_path__ + "static/media/1.2efb1f62.mp4";